/**
 * Created by DejanK on 10/8/2016.
 *
 * should have placeholder option
 */
import angular from 'angular';
import {debounce, startsWith, find, get} from 'lodash';

import './rb-select.scss';

const template =`<a href="#" tabindex="0" ng-click="$ctrl.onClick($event)" ng-keydown="$ctrl.onKey($event)" ng-bind-html="$ctrl.html" ng-blur="$ctrl.onBlur()"></a>
<div class="rb-hidden rb-select-overlay" ng-click="$ctrl.onOverlayClick()">
  <div class="rb-select-menu" ng-transclude></div>
</div>`;


export default {
  template: template,
  transclude: true,
  require: {
    ngModelController: 'ngModel'
  },
  bindings: {
    rbReadonly: '<'
  },
  controller: Ctrl
};

Ctrl.$inject = ['$sce', '$element', '$scope', '$document', 'rbSelectMenuPositioningService'];
function Ctrl($sce, $element, $scope, $document, rbSelectMenuPositioningService){
  const vm = this,
    options = [],
    singleCharRegexp = new RegExp('^[a-zA-Z0-9]$'),
    debouncedUpdateView = debounce(updateView, 5),
    debouncedSearch = debounce(search, 300);

  let
    elementClasses,
    modelValue,
    selectedOption,
    menuOverlayElement,
    menuContainerElement,
    focusedOption = null,
    isMenuShown = false,
    searchQuery = '';


  vm.registerOption = registerOption;
  vm.deregisterOption = deregisterOption;

  vm.$onInit = onInit;
  vm.$doCheck = doCheck;
  vm.$onDestroy = () => {
    if (menuOverlayElement) {
      menuOverlayElement.remove();
    }
  };
  vm.onClick = ($event)=>{stop($event); showMenu();};
  vm.onKey = onKey;
  vm.onSelect = onSelect;
  vm.onOverlayClick = close;
  vm.onBlur = setTouched;
  $scope.$on('RbWindowResized', () => {
    if (menuContainerElement) {
        rbSelectMenuPositioningService.setMenuPosition(menuContainerElement, $element, menuOverlayElement);
    }
  });

  function onInit(){
    elementClasses = getElementClasses($element.attr('class')).join(' ');

    function getElementClasses(classesString){
      const
        rawClasses = classesString.split(' '),
        classes = [],
        classesCount = rawClasses.length;

      let i=0;

      while(i<classesCount){
        const c = rawClasses[i];
        if(!startsWith(c, 'ng-')){
          classes.push(c);
        }
        i++;
      }
      return classes;
    }
  }

  function close(){
    if (isMenuShown) {
        menuOverlayElement.addClass('rb-hidden');
    }
    isMenuShown = false;
    $element.append(menuOverlayElement)
  }

  function doCheck(){
    if(modelValue !== vm.ngModelController.$viewValue) {
      modelValue = vm.ngModelController.$viewValue;
      updateView();
    }
  }

  function updateView(){
    selectedOption = null;
    for(let i=0, l=options.length; i<l; i++){
      const option = options[i];
      if(!selectedOption && option.value === modelValue) {
        selectedOption = option;
        vm.html = $sce.trustAsHtml(option.select());
        vm.isMenuOpened = false;
      } else {
        option.deselect();
      }
      option.removeFocus();
    }
    $scope.$applyAsync();
  }

  function showMenu(){
    if(vm.rbReadonly) return;

    if (!menuOverlayElement) {
        createMenuOverlayElement();
    }

    showMenuOverlayElement();

    function createMenuOverlayElement(){
      const parentWidth = $element && get($element[0], 'clientWidth');
      menuOverlayElement = angular.element($element.children()[1]);
      menuContainerElement = angular.element(menuOverlayElement.children()[0]);
      menuContainerElement.addClass(elementClasses ? elementClasses : '');

      if (parentWidth) {
        menuContainerElement.css('min-width', `${parentWidth - 1  }px`);
      }
      $document.find('body').eq(0).append(menuOverlayElement);
    }

    function showMenuOverlayElement(){
      menuContainerElement.css({top: '', left: '', right: '', bottom: ''});
      menuOverlayElement.removeClass('rb-hidden');
      rbSelectMenuPositioningService.setMenuPosition(menuContainerElement, $element, menuOverlayElement);
      if (selectedOption)  selectedOption.setFocus();
      focusedOption = selectedOption || options[0];
      focusOnOption(focusedOption);
      isMenuShown = true;
    }
  }

  function onSelect(selectedValue){
    vm.ngModelController.$setViewValue(selectedValue);
    close();
  }

  function onKey($event){
    if(vm.rbReadonly || $event.altKey || $event.ctrlKey) return;
    if(isMenuShown){
      stop($event);
      switch ($event.key){ // I can catch arrow clicks when menu is shown here
        case 'ArrowUp':
        case 'Up':
          focusOptionByIndex(options.indexOf(focusedOption) -1);
          return;
        case 'ArrowDown':
        case 'Down':
          focusOptionByIndex(options.indexOf(focusedOption) +1);
          return;
        case 'PageUp':
          focusOptionByIndex(options.indexOf(focusedOption) -6);
          return;
        case 'PageDown':
          focusOptionByIndex(options.indexOf(focusedOption) +6);
          return;
        case 'Home':
          focusOnOption(options[0]);
          return;
        case 'End':
          focusOnOption(options[options.length-1]);
          return;
        case 'Escape':
        case 'Esc':
          close();
          return;
        case 'Enter':
        case ' ':
        case 'Spacebar':
          vm.onSelect(focusedOption.value);
          return;
        default:
          return;
      }
    } else {
      if($event.key === 'ArrowDown' || $event.key === 'Down'){
        stop($event);
        showMenu()
      }
    }

    if(singleCharRegexp.test($event.key)){
      searchQuery += $event.key;
      debouncedSearch();
    }

    function focusOptionByIndex(index){
      focusOnOption(options[index < 0 ? 0 : index >= options.length ? options.length-1 : index])
    }
  }

  function stop($event){
    $event.stopPropagation();
    $event.preventDefault();
  }

  function focusOnOption(option){
    focusedOption.removeFocus();
    focusedOption = option;
    focusedOption.setFocus();
  }

  function search(){
    searchQuery = searchQuery.toLowerCase();
    const foundOption = find(options, (o)=>{
      return startsWith(o.getText().toLowerCase(), searchQuery)
    });
    searchQuery = '';

    if(foundOption) {
      if (isMenuShown) {
        focusOnOption(foundOption);
      } else {
        onSelect(foundOption.value);
      }
    }
  }

  function registerOption(option){
    options.push(option);
    debouncedUpdateView();
  }

  function deregisterOption(option){
    const index = options.indexOf(option);
    if(index !== -1) options.splice(index, 1);
  }

  function setTouched(){
    vm.ngModelController.$setTouched();
  }
}
